import baseApi from "./baseApi";
import axios from "axios";



const isAuthenticated = () => axios.get("account/IsAuthenticated", { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
const login = (r) => axios.post("account/login", r);
const register = (r) => axios.post("account/register", r);
const confirm = (r) => axios.post("account/confirm", r);
const forgotpassword = (r) => axios.post("account/forgotpassword", r);
const changePassword = (r) => axios.post("account/changepassword", r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });

const resendCode = (r) => axios.post("account/resendCode", r);
// const logout = () => axios.delete("login");
// const passwordReset = (r) => axios.post("passwordreset", r);
// const passwordResetComplete = (r) => axios.post("passwordreset/complete", r);
const userProfile = () => axios.get(`account/userprofile`, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
const updateUserProfile = (r) => axios.put(`account/userprofile`, r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });

const captcha = (r) => axios.get("Captcha/Create");


export default {
    confirm,
    isAuthenticated,
    login,
    captcha,
    confirm,
    forgotpassword,
    changePassword,
    // logout,
    // passwordReset,
    // passwordResetComplete,
    register,
    // user,
    userProfile,
    updateUserProfile,
    resendCode
};